import { SubRowTable, SubRowTableColumn } from '@psyomics/ui-components';
import { useTranslation } from 'react-i18next';

import { ReferralUploadJobResult } from './types';

type ErroredRow = ReferralUploadJobResult['erroredRows'][number];
type ReferralUploadJobErrorsProps = {
  readonly job: ReferralUploadJobResult;
};

const ReferralUploadJobErrors = ({ job }: ReferralUploadJobErrorsProps) => {
  const { t } = useTranslation();

  const columns: SubRowTableColumn<ErroredRow>[] = [
    {
      header: t('page.referralUploadJobs.erroredRows.rowNumber'),
      render: (row) => row.rowNumber,
    },
    {
      header: t('page.referralUploadJobs.erroredRows.name'),
      render: (row) => `${row.givenName} ${row.familyName}`,
    },
    {
      header: t('page.referralUploadJobs.erroredRows.eprId'),
      render: (row) => `${row.eprId}`,
    },
    {
      header: t('page.referralUploadJobs.erroredRows.error'),
      render: (row) => row.errorMessage,
    },
  ];

  return (
    <SubRowTable
      columns={columns}
      emptyMessage={t('page.referralUploadJobs.erroredRows.none')}
      rows={job.erroredRows}
    />
  );
};

export { ReferralUploadJobErrors };
